import { DailyRecurrenceConfig } from './DailyRecurrenceConfig';
import { WeeklyRecurrenceConfig } from './WeeklyRecurrenceConfig';
import { MonthlyRecurrenceConfig } from './MonthlyRecurrenceConfig';

/**
 * Outlook-style recurrence selector with type-specific configuration
 */
export function RecurrenceSelector({ recurrence, onChange }) {
  const handleChange = (field, value) => {
    onChange({
      ...recurrence,
      [field]: value
    });
  };

  return (
    <div className="recurrence-selector">
      {/* Recurrence Type */}
      <div className="form-group">
        <label>Wiederholungs-Typ</label>
        <div className="recurrence-type-buttons">
          <button
            type="button"
            className={`recurrence-btn ${recurrence.type === 'daily' ? 'active' : ''}`}
            onClick={() => {
              onChange({
                ...recurrence,
                type: 'daily',
                daysOfWeek: [], // Empty array for daily
                monthlyPattern: null
              });
            }}
          >
            <i className="fas fa-calendar-day"></i>
            Täglich
          </button>
          <button
            type="button"
            className={`recurrence-btn ${recurrence.type === 'weekly' ? 'active' : ''}`}
            onClick={() => {
              onChange({
                ...recurrence,
                type: 'weekly',
                daysOfWeek: [1], // Monday as default
                monthlyPattern: null
              });
            }}
          >
            <i className="fas fa-calendar-week"></i>
            Wöchentlich
          </button>
          <button
            type="button"
            className={`recurrence-btn ${recurrence.type === 'monthly' ? 'active' : ''}`}
            onClick={() => {
              onChange({
                ...recurrence,
                type: 'monthly',
                daysOfWeek: [], // Empty array for monthly
                monthlyPattern: {
                  week: 'first',
                  dayOfWeek: 1
                }
              });
            }}
          >
            <i className="fas fa-calendar-alt"></i>
            Monatlich
          </button>
        </div>
      </div>

      {/* Daily Configuration */}
      {recurrence.type === 'daily' && (
        <DailyRecurrenceConfig recurrence={recurrence} onChange={onChange} />
      )}

      {/* Weekly Configuration */}
      {recurrence.type === 'weekly' && (
        <WeeklyRecurrenceConfig recurrence={recurrence} onChange={onChange} />
      )}

      {/* Monthly Configuration */}
      {recurrence.type === 'monthly' && (
        <MonthlyRecurrenceConfig recurrence={recurrence} onChange={onChange} />
      )}
    </div>
  );
}
